import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

import type { IInputProps } from './IInputProps';
import styles from './Input.module.css';

const Input = forwardRef<HTMLInputElement, IInputProps>(
  (props, forwardedRef) => {
    const {
      description: Description,
      error: Error,
      className,
      ...rest
    } = props;

    return (
      <>
        <input
          className={twMerge(
            `w-full accent-retail-primary-700 rounded-xl border border-gray-400 p-4 focus:outline-2 focus:outline-retail-primary-900 disabled:outline disabled:outline-retail-gray-200 disabled:accent-retail-gray-200 disabled:focus:outline disabled:focus:outline-retail-gray-200 disabled:focus:accent-retail-gray-200 placeholder:text-base md:placeholder:text-lg placeholder-retail-text-placeholder h-12 md:h-14 ${styles.retailInput}`,
            className
          )}
          ref={forwardedRef}
          {...rest}
        />
        {Description ? (
          <span className="text-retail-text-tertiary mt-2 block text-start text-sm md:text-base">
            {Description}
          </span>
        ) : null}
        {Error ? (
          <span className="text-retail-red-600 mt-2 text-sm md:text-base">
            {Error}
          </span>
        ) : null}
      </>
    );
  }
);

Input.displayName = 'Input';

export default Input;
